
import 'babel-polyfill';
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import VueMask from 'v-mask'
Vue.use(VueMask);


import App from './App.vue'
import router from './router'
import store from './store'

import { i18n, loadLanguageAsync } from '@/plugins/i18n'

import Vuetify from "vuetify"
import 'vuetify/dist/vuetify.min.css'

import '@mdi/font/css/materialdesignicons.css'
import "@/assets/style.css"

Vue.use(Vuetify);

const vuetifyOpts = {
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    },

    theme: {
        dark: false,
        themes: {
            light: {
                primary: {
                    base: '#22366A'
                },
                success: '#28AD68',
                error: '#DA3951',
                info: '#2196F3',
                warning: '#F7893B',
                infoLight: '#50c3d1',
            },
        },
    }
}

Vue.config.productionTip = false
import Utilities from '@/Utilities.js'
import { FormMixIn } from "@/MixIns/FormMixins";
Vue.config.devtools = true;
new Vue({
    router,
    store,
    mixins: [FormMixIn],
    vuetify: new Vuetify(vuetifyOpts),
    i18n,
    methods:
    {
        KeepAlive()
        {
            return;
        },
        loadLanguageAsync(lang)
        {
            loadLanguageAsync(lang);
        }
    },
    mounted: function ()
    {
        const self = this;

        const hostUrl = window.location.origin + '/';

        self.$store.commit('SetHostUrl', hostUrl);

        if (['account'].includes(window.location.hash.toLowerCase().replace('#/', '').split('/')[0]) === false)
        {
            self.$store.dispatch("GetUserInfo")
                .then(response =>
                {
                    if (response.data.errorCode == 0)
                    {
                        if (response.data.result.Login == 0)
                        {
                            self.PushToRouter({ name: 'login' });
                        }
                        else
                        {
                            self.$store.commit("SetUserLoggedIn", response.data.result.Login == '1');
                            if (self.IsApprovedPage(self.$route.name) && !response.data.result.approved)
                            {
                                self.PushToRouter({ name: 'home' });
                            }
                        }
                    }
                    else
                    {
                        self.PushToRouter({ name: 'login' });
                    }
                })
                .catch(err =>
                {
                    window.location.hash = '#/Account/Login';
                });
        }
    },
    render: h => h(App)
}).$mount('#app')

